import { LiaLinkedinIn } from "react-icons/lia";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const footerLinks = [
  {
    title: "About",
    links: [
      { label: "Terms and condition", to: "/" },
      { label: "Privacy Policy", to: "/" },
      { label: "Contact Us", to: "/" },
    ],
  },
  {
    title: "Product",
    links: [
      { label: "Pricing", to: "/" },
      { label: "Testimonials", to: "/" },
    ],
  },
  {
    title: "Discover",
    links: [
      { label: "Teams", to: "/" },
      { label: "Partners", to: "/" },
      { label: "Career", to: "/" },
    ],
  },
];

function Footer() {
  const itemZ = {
    hidden: { opacity: 0, scale: 0.4 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  return (
    <footer
      style={{
        position: "relative",
        backgroundImage: "url(/footer.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="text-white pt-12 pb-14"
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.8)",
          zIndex: -1,
        }}
      ></div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="flex flex-wrap flex-col sm:flex-row justify-start md:justify-between gap-8">
          <motion.div
            variants={itemZ}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <img src="/logo2.svg" alt="Logo" />
          </motion.div>

          {footerLinks.map((col, idx) => (
            <motion.div
              key={idx}
              variants={itemZ}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <h3
                className="font-bold mb-3"
                style={{ color: "#C9F2EE", fontSize: "16px" }}
              >
                {col.title}
              </h3>
              <ul className="flex flex-col gap-2">
                {col.links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.to}
                      style={{ color: "#BEBEBE", fontSize: "15px" }}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}

          <motion.div
            variants={itemZ}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <h3
              className="font-bold mb-4"
              style={{ color: "#C9F2EE", fontSize: "16px" }}
            >
              Follow Us
            </h3>
            <a
              href="https://www.linkedin.com/company/datagenx-ai"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-end gap-2 w-fit py-2 transition-all duration-300 hover:bg-white/10"
              style={{
                borderRadius: "8px",
                color: "#BEBEBE",
                fontSize: "14px",
              }}
            >
              <div
                className="rounded-md"
                style={{ border: "2px solid #BEBEBE", marginBottom: "3px" }}
              >
                <LiaLinkedinIn size="22" />
              </div>
              <span>DATAGENX</span>
            </a>
          </motion.div>
        </div>

        <motion.div
          className="mt-24 text-left md:text-center text-sm"
          variants={itemZ}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.8 }}
        >
          <span>© 2025 - All Rights Reserved DATAGENX</span>
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;
